import React from 'react'

const Principal= props => <h1 className="center-align flow-text">{props.title}</h1>

export default Principal

